<template>
  <div id="events-preview">
    <v-toolbar color="#8950FC">
      <v-toolbar-title>
        <h1 class="text-white">{{ pageTitle }}</h1>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn icon dark @click="closePrompt">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card>
      <v-card-title>
        <!-- <span class="headline">{{ pageDescription }}</span> -->
      </v-card-title>

      <v-card-text>
        <v-dialog eager v-model="FilePreviewFlag" v-if="FilePreviewFlag">
          <pdf-document-file-preview
            PageTitle="File Preview"
            :PreviewButtonFlag="FilePreviewFlag"
            :Documentpath="row.ConsolidateFilePath"
            @hideDialog="hideFilePreviewFlag"
            v-if="FilePreviewFlag"
          ></pdf-document-file-preview>
        </v-dialog>

        <div class="d-flex justify-content-center mb-3" v-if="LoadingFlag">
          <b-spinner
            variant="primary"
            type="grow"
            label="Loading..."
          ></b-spinner>
        </div>

        <v-container v-if="ResultFlag">
          <v-row wrap>
            <v-col cols="12" sm="6" lg="3" md="3">
              <h5 class="blue--text text--lighten">Submitted Date</h5>
              <p class="preview-content">{{ row.UpdatedAtTxt }}</p>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <h5 class="blue--text text--lighten">Portfolio</h5>
              <p class="preview-content">{{ row.PortfolioName }}</p>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <h5 class="blue--text text--lighten">Category</h5>
              <p class="preview-content">{{ row.EventTypeName }}</p>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <h5 class="blue--text text--lighten">Sub Category</h5>
              <p class="preview-content">{{ row.EventSubTypeName }}</p>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <h5 class="blue--text text--lighten">Host Details</h5>
              <p class="preview-content" v-if="row.IsNhqHost">Jci NHQ</p>
              <p class="preview-content" v-else>
                {{ row.HostZoneName }} - {{ row.HostLomName }}
              </p>
            </v-col>
          </v-row>
          <hr />
          <v-row wrap>
            <v-col cols="12" sm="6" lg="3" md="3">
              <h5 class="blue--text text--lighten">Event Date</h5>
              <p class="preview-content">
                {{ row.DateFromTxt }} -
                {{ row.DateToTxt == 1 ? row.DateToTxt : "" }}
              </p>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <h5 class="blue--text text--lighten">Event Type</h5>
              <p class="preview-content">{{ row.OrganizationTypeName }}</p>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <h5 class="blue--text text--lighten">LOM</h5>
              <p class="preview-content">
                {{ row.ZoneName }} - {{ row.LomName }}
              </p>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <h5 class="blue--text text--lighten">100% efficency</h5>
              <p class="preview-content">{{ row.SubCriteriaTxt }}</p>
              <p class="preview-content">
                {{ row.PointsTypeName }} - {{ row.PointsValue }} pts
              </p>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <h5 class="blue--text text--lighten">Event Name</h5>
              <p class="preview-content">{{ row.JciEventName }}</p>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <h5 class="blue--text text--lighten">Venue</h5>
              <p class="preview-content">{{ row.VenueDetails }}</p>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <h5 class="blue--text text--lighten">Invitation</h5>
              <viewer rebuild :images="row.InvitationImages">
                <img
                  style="padding: 5px"
                  width="200"
                  height="200"
                  :src="src"
                  :key="src"
                  v-for="src in row.InvitationImages"
                />
              </viewer>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <h5 class="blue--text text--lighten">Group photo</h5>
              <viewer rebuild :images="row.WebsiteImages">
                <img
                  style="padding: 5px"
                  width="200"
                  height="200"
                  :src="src"
                  :key="src"
                  v-for="src in row.WebsiteImages"
                />
              </viewer>
            </v-col>
          </v-row>
          <v-row wrap>
            <v-col cols="12" sm="12" lg="12" md="12">
              <h5 class="blue--text text--lighten">Description</h5>
              <p class="preview-content">{{ row.JciEventDescription }}</p>
            </v-col>
          </v-row>
          <v-row wrap>
            <v-col cols="12" sm="12" lg="12" md="12">
              <h5 class="blue--text text--lighten">Event Photos</h5>
              <viewer rebuild :images="row.EventImages">
                <img
                  style="padding: 5px"
                  width="200"
                  height="200"
                  :src="src"
                  :key="src"
                  v-for="src in row.EventImages"
                />
              </viewer>
              <!-- <v-data-iterator
                :items="DocumentsData"
                :items-per-page="-1"
                hide-default-footer
              >
                <template v-slot:header> </template>

                <template v-slot:default="props">
                  <v-row>
                    <v-col
                      v-for="document in props.items"
                      :key="document.EventDocumentId"
                      cols="12"
                      sm="6"
                      md="4"
                      lg="3"
                    >
                      <v-card raised hover ripple elevation="25">
                        <v-card-text>
                          <v-avatar size="100">
                            <img
                              :src="document.DocumentPublicPath"
                              :alt="document.DocumentTypeName"
                            />
                          </v-avatar>
                          <h3>{{ document.DocumentTypeName }}</h3>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </template>
              </v-data-iterator> -->
            </v-col>
          </v-row>
          <v-row wrap>
            <v-col cols="12" sm="6" lg="4" md="4">
              <h5 class="blue--text text--lighten">Event Chairman</h5>
              <div v-if="row.ChairmanFlag">
                <v-card raised hover ripple elevation="25">
                  <v-card-text class="text-center">
                    <v-avatar size="100">
                      <img
                        :src="ChairmanData.ChairmanMemberPublicPath"
                        :alt="ChairmanData.ChairmanMemberFullname"
                        v-if="ChairmanData.ChairmanMemberPublicPath != ''"
                      />
                    </v-avatar>
                    <h3>
                      {{ ChairmanData.ChairmanMemberFullname }}
                    </h3>
                    <h3 class="text-primary">
                      {{ ChairmanData.ChairmanMemberDetails }}
                    </h3>
                  </v-card-text>
                </v-card>
              </div>
              <div v-else>NA</div>
            </v-col>
            <v-col cols="12" sm="6" lg="4" md="4">
              <h5 class="blue--text text--lighten">Event Director</h5>
              <div v-if="row.DirectorFlag">
                <v-card raised hover ripple elevation="25">
                  <v-card-text class="text-center">
                    <v-avatar size="100">
                      <img
                        :src="DirectorData.DirectorMemberPublicPath"
                        :alt="DirectorData.DirectorMemberFullname"
                        v-if="DirectorData.DirectorMemberPublicPath != ''"
                      />
                    </v-avatar>
                    <h3>
                      {{ DirectorData.DirectorMemberFullname }}
                    </h3>
                    <h3 class="text-primary">
                      {{ DirectorData.DirectorMemberDetails }}
                    </h3>
                  </v-card-text>
                </v-card>
              </div>
              <div v-else>NA</div>
            </v-col>
          </v-row>
          <v-row wrap>
            <v-col cols="12" sm="12" lg="12" md="12">
              <h5 class="blue--text text--lighten">Dignitaries</h5>
              <v-data-iterator
                :items="FacultiesData"
                :items-per-page="-1"
                hide-default-footer
              >
                <template v-slot:header> </template>

                <template v-slot:default="props">
                  <v-row>
                    <v-col
                      v-for="faculty in props.items"
                      :key="faculty.EventFacultyId"
                      cols="12"
                      sm="6"
                      md="4"
                      lg="3"
                    >
                      <v-card raised hover ripple elevation="25">
                        <v-card-text class="text-center">
                          <v-avatar size="100">
                            <img
                              :src="faculty.FacultyMemberPublicPath"
                              :alt="faculty.FacultyMemberName"
                            />
                          </v-avatar>
                          <h3>
                            {{ faculty.FacultyMemberName }}
                          </h3>
                          <h3>
                            {{ faculty.FacultyTypeName }}
                          </h3>
                          <h3 class="text-primary">
                            {{ faculty.FacultyMemberDetails }}
                          </h3>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </template>
              </v-data-iterator>
            </v-col>
          </v-row>
          <v-row wrap>
            <v-col align="center" cols="12" md="12">
              <v-btn
                v-if="row.ConsolidateFilePath != ''"
                @click="FilePreviewFlag = true"
                color="primary"
                elevation="30"
                shaped
                tile
                large
                class="btn btn-primary font-size-h6 px-15 py-4 my-3 mr-3 white--text"
              >
                Uploaded file preview
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closePrompt"> Cancel </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";

export default {
  mixins: [common],
  components: {},
  props: {
    previewRecordPrompt: {
      type: Boolean,
      required: true,
    },
    recordData: {
      required: true,
    },
    pageTitle: {
      type: String,
    },
    pageDescription: {
      type: String,
    },
  },
  data() {
    return {
      tableColumns1: [],
      tableOptions1: {},
      tableData1: [],

      row: {},
      ResultFlag: false,

      PreviewButtonFlag: false,
      Documentpath: "",

      LoadingFlag: false,

      TableFlag1: false,

      selected: [],
      SearchFlag: false,
      search: "",

      ChairmanData: {},
      DirectorData: {},
      DocumentsData: [],
      FacultiesData: [],

      defaultItem: {
        name: "",
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },

      FilePreviewFlag: false,
    };
  },
  computed: {},
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  created() {
    // this.initialize()
  },
  methods: {
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hidePreviewRecordPrompt");
    },
    validate() {
      console.log("validate is called");
      var result = this.$refs.form.validate();
      console.log("result=" + result);
      if (result) {
        this.addRecordDetails();
      } else {
        console.log("some errors occured");
      }
    },
    hideFilePreviewFlag() {
      console.log("hideFilePreviewFlag called");
      this.FilePreviewFlag = false;
    },
    hidePreviewRecordPrompt() {
      console.log("hidePreviewRecordPrompt called");
      this.previewRecordPrompt = false;
    },
    previewData(tr) {
      console.log("previewData called");
      // var tr = this.selected
      // var n1 = tr.length
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.Documentpath = tr.DocumentAssetPath;
        this.previewRecordPrompt = true;
      } else {
        var message = "Kindly select one record to preview";
        this.toast("error", message);
      }
    },
    refreshPageData() {
      console.log("refreshPageData called");
      var recordData = this.recordData;
      console.log("recordData=" + JSON.stringify(recordData));
      this.getTableRecords();
    },
    getTableRecords() {
      console.log("getTableRecords called");

      var JciEventId = this.recordData.JciEventId;
      console.log("JciEventId=" + JciEventId);

      if (JciEventId != "") {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/jci-events/show";
        var upload = {
          UserInterface: 1,
          EventCode: JciEventId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        this.row = {};
        this.ChaimanData = {};
        this.DirectorData = {};
        this.DocumentsData = [];
        this.FacultiesData = [];
        this.ResultFlag = false;

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.LoadingFlag = true;
        this.Documentpath = "";

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.LoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            var options = response.data.options;
            var TableHeader = options.TableHeader;
            var TableOptions = options.TableOptions;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            thisIns.ResultFlag = flag;
            thisIns.tableColumns1 = TableHeader;
            thisIns.tableOptions1 = TableOptions;

            if (flag == 1) {
              thisIns.row = records;
              thisIns.ChairmanData = records.ChairmanData;
              thisIns.DirectorData = records.DirectorData;
              thisIns.DocumentsData = records.Documents;
              thisIns.FacultiesData = records.Faculties;
              // thisIns.toast("success", output);
            } else {
              // thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.toast("error", error);
            thisIns.LoadingFlag = false;
          });
      } else {
        var message = "Your session is expired. Kindly login again. ";
        console.log("error=" + message);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
<style lang="scss">
/* This is for documentation purposes and will not be needed in your application */

#events-preview {
  .preview-content {
    font-size: 14px;
    font-weight: normal;
    line-height: 1.5em;
  }
}
</style>